import { Box, type BoxProps } from "@mui/material";
import type { ReactNode } from "react";

type CenteredContainerProps = {
  children: ReactNode;
  maxWidth?: number;
} & Omit<BoxProps, "maxWidth" | "children">;

/** Narrow reading column used on article and profile screens. */
export function CenteredContainer({
  children,
  maxWidth = 720,
  ...boxProps
}: CenteredContainerProps) {
  return (
    <Box sx={{ maxWidth, mx: "auto" }} {...boxProps}>
      {children}
    </Box>
  );
}
